import React, { Fragment } from 'react';

import BaseModal from '../general/BaseModal';
import UserStore from '../../stores/UserStore';
import Address from './Address';
import { AccountPages } from '../../constants/AppConstants';
import Link from '../general/Link';
import { translate as t } from '../../lib/I18n';

export const ChildSmartCardExpirationModal = () => {
    const [isModalOpen, setIsModalOpen] = React.useState(true);
    const toggleModal = () => setIsModalOpen(!isModalOpen);

    const user = UserStore.getCurrent();
    const smartCardAddress = user.getSmartcardAddress();

    return (
        <BaseModal
            className="modal--sm"
            show={isModalOpen}
            onClose={toggleModal}
            hideContinue
            titleText={t('transitioning-child-smartcard.modal.title')}
        >
            <div>
                <p>{t('transitioning-child-smartcard.modal.paragraph.1')}</p>
                <p>{t('transitioning-child-smartcard.modal.paragraph.2')}</p>
                <p>{t('transitioning-child-smartcard.modal.paragraph.3')}</p>
                {smartCardAddress && (
                    <Fragment>
                        <p>{t('transitioning-child-smartcard.modal.paragraph.4')}</p>
                        <Address
                            address={smartCardAddress}
                            className="margin-top--sm margin-bottom--sm text-weight--normal"
                        />
                        <p>
                            {t('transitioning-child-smartcard.modal.paragraph.5.1')}
                            <Link to={AccountPages.ACCOUNT_ADDRESSES} onClick={toggleModal}>
                                {t('transitioning-child-smartcard.modal.paragraph.5.address.link')}
                            </Link>
                            {t('transitioning-child-smartcard.modal.paragraph.5.2')}
                        </p>
                    </Fragment>
                )}
            </div>
        </BaseModal>
    );
};
